import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { SourceDialogComponent } from '../source-dialog/source-dialog';
import { NewEntryService } from '../../services/new-entry.service';
import * as _ from 'lodash';
import { OkDialogService } from '../../services/ok-dialog.service';
import { NewSourceModel } from '../../models/new-source.model';
import { SourceService } from '../../services/source.service';


@Component({
  selector: 'app-mare-mekomos',
  templateUrl: './mare-mekomos.component.html',
  styleUrls: ['./mare-mekomos.component.scss']
})
export class MareMekomosComponent implements OnInit {

  @Input() gridApi;
  @Input() entry;
  @Output('updated') updatedEventEmitter = new EventEmitter();


  constructor(
    private matDialog:MatDialog,
    private newEntryService:NewEntryService,
    private okDialogService:OkDialogService,
    private sourceService:SourceService,
  ) {

  }

  ngOnInit() {
  }


  addMareMakom() {
    console.log('this.entry', this.entry);

    const dialogRef = this.matDialog.open(SourceDialogComponent, {
      data: {},
    });

    dialogRef.afterClosed().subscribe(async result => {

      console.log('result', result);

      if (result) {

        const newSources = _.clone(this.entry.sources);
        newSources.push(result);

        this.saveSources(newSources);

      } else if (result === false) {

        // user canceled

      } else if (result === 'error') {
        this.okDialogService.show('Invalid source');
      } else {
        this.okDialogService.show('Unknown error -- contact developer');
      }


    });

  }


  editMareMakom(source) {
    console.log('this.entry', this.entry);

    const editedSourceId = source._id;

    const dialogRef = this.matDialog.open(SourceDialogComponent, {
      data: {
        source,
      },
    });

    dialogRef.afterClosed().subscribe(async result => {

      console.log('result', result);

      if (result) {

        const newSources = _.clone(this.entry.sources).map(source => {

          if (source._id === editedSourceId) {
            return result;
          } else {
            return source;
          }

        });

        this.saveSources(newSources);

      } else if (result === false) {

        // user canceled

      } else if (result === 'error') {
        this.okDialogService.show('Invalid source');
      } else {
        this.okDialogService.show('Unknown error -- contact developer');
      }


    });
  }


  removeMareMakom(id) {

    const newSources = this.entry.sources.filter(source => source._id !== id);

    this.saveSources(newSources);

  }



  pasteMareMakom(numSourceSlot) {

    const sourceToPaste = this.sourceService.getSourceSlotToPaste(numSourceSlot);


    const newSources = _.clone(this.entry.sources);
    newSources.push(sourceToPaste);

    this.saveSources(newSources);
  }


  copyMareMakom(source) {
    this.sourceService.addToSourceSlots(source);
  }

  hasSourceSlot(numSourceSlot) {
    return this.sourceService.hasSourceSlot(numSourceSlot);
  }



  reorderMareMakom(sourceToMove, direction) {
    console.log('sourceToMove', sourceToMove);
    console.log('direction', direction);

    const sourceToMoveId = sourceToMove._id;
    const sourceIndex = this.entry.sources.findIndex(source => source._id == sourceToMoveId );
    console.log('sourceIndex', sourceIndex);

    // nothing to do...
    if (sourceIndex == 0  &&  direction == -1) return;
    if (sourceIndex == this.entry.sources.length - 1  &&  direction == 1) return;


    const newSources = _.clone(this.entry.sources);
    const sourceMoving = newSources.splice(sourceIndex, 1)[0];
    newSources.splice(sourceIndex + direction, 0, sourceMoving);

    console.log('sourceMoving', sourceMoving);
    console.log('newSources', newSources);

    this.saveSources(newSources);
  }


  saveSources(newSources) {

    let hasLiteralSources = false;

    newSources.forEach((source:NewSourceModel) => {
      if (source.isLiteral) hasLiteralSources = true;
    });


    this.newEntryService.patch(this.entry._id, {
      hasSources: (newSources.length > 0),
      hasLiteralSources,
      sources: newSources,
    })
      .then(newEntry => {

        // clear sources before merge
        this.entry.sources = [];

        this.entry = newEntry;
        this.gridApi.updateRowData({update: [this.entry]});
        this.updatedEventEmitter.emit(newEntry);

      });
  }
}




// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/mare-mekomos/mare-mekomos.component.ts